module.exports = __webpack_public_path__ + "static/media/25.a5017b6c.svg";